export const UserGroup = {
    Everyone: 'ce684f6f-5af3-4e43-8516-1adad6e98fc9',
    AutomationUsers: 'cdc34b5b-77d2-4ae1-9744-209d21ce557d',
    Administrators: '35551807-06b1-4cda-90a1-2fb84851eee7',
    AutomationDevelopers: '4d161738-7204-4794-b839-8f7fed28366c',
};
